import { combineReducers } from "redux";
import * as reducerTimeslots from "./reducerTimeslots";
import * as reducerLocations from "./reducerLocations";
import * as reducerProviders from "./reducerProviders";
import * as reducerAppointment from "./reducerAppointment";
import * as reducerSelectedDate from "./reducerSelectedDate";

import * as reducerUser from "./reducerUser";

export default combineReducers(
  Object.assign(
    reducerTimeslots,
    reducerLocations,
    reducerProviders,
    reducerAppointment,
    reducerSelectedDate,
    reducerUser
  )
);
